<p>client-analytics works!</p>
